<template lang="pug">
.ft(:class="{home: $route.path != '/profile' && $route.path != '/newUser'}")
  .ftLeft
    .text(v-html="text.left")
    .edulogo
  .ftRight
    .right_block
      .text.privacy(@click="dialogVisible = true") 隱私權聲明
      el-dialog(:visible.sync="dialogVisible" width="90%" :modal-append-to-body="false")
        .privacy_block
          span(v-html="text.privacy_text")
      span.text 網站更新日期: {{updateTime}} －
      span.text 瀏覽人數：{{visitor_count}} 人次
</template>

<script>
export default {
  props: {
    updateTime: {
      type: String,
      default: '2023/11/23'
    },
    visitor_count: {
      type: String,
      default: '000000'
    }
  },
  data() {
    return {
      dialogVisible: false,
      text: {
        left: '<div><div>教育部版權所有</div><div>地址：臺北市中正區中山南路5號</div><div>電話總線：(02)7736-6666 (代表號)</div></div>',
        privacy_title: '教育部資通安全及隱私權政策聲明',
        privacy_text: `<p style="text-align: center; line-height: 26pt; margin: 0cm 0cm 0.0001pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><strong><span style="font-size: 16.0pt; font-family: 標楷體;">教育部資通安全及隱私權政策聲明</span></strong><strong><span style="font-size: 16.0pt;"></span></strong><strong><span style="font-size: 16.0pt; font-family: 標楷體;"></span></strong><strong><span style="font-size: 16.0pt;"></span></strong><strong><span style="font-size: 16.0pt; font-family: 標楷體;"></span></strong></p>
          <p style="margin: 6pt 0cm; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">歡迎蒞臨美感教育資源整合平台（以下簡稱本網站），本網站尊重並保護您在使用教育部網路時的安全及隱私保護權利，為了幫助您瞭解本網站如何保護您在使用本網站各項服務的安全、及如何蒐集、運用及保護您所提供的資訊，特於此說明本網站的資通安全及隱私政策。</span></p>
          <ul style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">適用範圍</span></li>
          </ul>
          <p style="margin: 6pt 0cm 6pt 28.3pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">本資通安全及隱私政策適用於您在本網站，以及其延伸服務網站等所涉及的個人資料之蒐集、運用與保護。但不適用於您經由本網站搜尋連結至其他網站後所進行之活動，關於其他網站的個人資料之保護，適用其各自之隱私權保護政策，本網站不負任何連帶責任。</span></p>
          <ul style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">個人資料之蒐集及運用</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">當您在瀏覽本網站或下載檔案時，不會蒐集任何您的個人身分有關之資訊。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">當您參與本網站之各項線上服務時，將視服務需求請您提供相關之個人資料。對於您所提供之個人資料，我們將會遵循「個人資料保護法」及相關法令規定，在本部所提供之業務範圍內使用，不會將其應用於蒐集特定目的以外之用途。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">本網站將在特定目的或法令許可範圍內，對取得之個人資料進行處理、利用、保管及傳輸，期間自該項服務啟始日起，至該項服務之保存年限為止，</span><span style="font-family: 標楷體;">利用地區為中華民國領域。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">本網站有義務保護您的個人隱私，不會任意修改或刪除您的個人資料及檔案。除非經過您同意或符合以下情況：</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">依法配合相關權責機關之要求。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">保護或防衛相關網路民眾的權利。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">為保護本網站各相關單位之權益。</span></li>
          </ol>
          </li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">本網站絕不會任意出售、交換或出租任何您的個人資料給其他團體、個人或私人企業。除非經過您同意或符合以下情況：</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">配合司法單位合法的調查。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">依法配合相關權責機關職務需要之調查或使用。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">符合相關法令與規範之安全保護要求下，進行網站服務維護管理及系統調整等作業。</span></li>
          </ol>
          </li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">本網站在您瀏覽或查詢網頁資料時，伺服器會自動產生並儲存相關使用紀錄，包括您使用連線設備的</span>IP<span style="font-family: 標楷體;">位址、使用時間、瀏覽網頁及點擊資料等紀錄，這些資料將僅作為本網站網路流量和行為的統計分析，以利於改進系統效能與提升服務品質。絕不會涉及使用者個人資料與行為之對應或分析。</span></li>
          </ol>
          </li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">資通安全機制</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">本網站為確保各項服務之正常運作，以及維護個人資料之安全，防範未經授權之變造竄改，或企圖入侵伺服器主機等惡意行為，提供了以下的安全保護措施：</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">裝設防火牆及入侵偵測防禦系統</span>IDP (Intrusion Detection Prevention)<span style="font-family: 標楷體;">防止非法入侵，避免非法存取使用。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">建置網路流量管理系統，有效管制異常網路流量。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">建立資通安全事件監控、通報與應變處理機制。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">網站資料定期備份，並備份到備援主機。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">網站主機不定期進行弱點掃描與系統漏洞修補。</span></li>
          </ol>
          </li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的小型文字檔案（以下簡稱</span>Cookie<span style="font-family: 標楷體;">），若您不願接受</span>Cookie<span style="font-family: 標楷體;">的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕</span>Cookie<span style="font-family: 標楷體;">的寫入，但可能會導致網站某些功能無法正常執行。</span></li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">為了提供更好、更個人化的服務以及方便您參與個人化的互動活動，</span>Cookies<span style="font-family: 標楷體;">會在您註冊或登入時建立，並在您登出時修改其狀態。</span></li>
          </ol>
          </li>
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">使用者條款</span>
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">使用者之義務及承諾</span></li>
          </ol>
          </li>
          </ul>
          <p style="margin: 6pt 0cm 6pt 48pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">使用者須恪遵『臺灣學術網路管理規範』及相關法令等規定，承諾絕不為任何非法目的或以任何非法方式使用本服務。您同意並保證不得利用本網站從事侵害他人權益或違法之行為，任何危害本網站資通安全之行為人，視情節輕重追究其法律責任。</span></p>
          <ul style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="list-style: none; margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;">
          <ol style="margin-top: 6.0pt; margin-bottom: 6.0pt;" start="2">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">個人自我保護措施</span></li>
          </ol>
          </li>
          </ul>
          <p style="margin: 6pt 0cm 6pt 48pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">請妥善保管您的帳號、密碼及任何個人資料，切勿將個人資料提供給任何人，尤其是密碼。提醒您於登入本網站所提供之各項服務之網頁後，在離開本網站之前，務必登出</span>(Logout)<span style="font-family: 標楷體;">帳號。若您使用共用或公共電腦（如：圖書館、電腦教室等），切記要關閉瀏覽器視窗，以防止他人讀取您的個人資料並保障您的權益。</span></p>
          <ul style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">資通安全及隱私權政策修訂</span></li>
          </ul>
          <p style="margin: 6pt 0cm 6pt 28.3pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">本網站將因應社會環境、法令規定及科技技術之變遷，不定時修訂本資通安全及隱私權政策聲明，並公告於本網站，以維護您瀏覽網站的安全及相關權益，並落實保障網路安全的立意。</span></p>
          <ul style="margin-top: 6.0pt; margin-bottom: 6.0pt;">
          <li style="margin: 6pt 0cm 6pt 0px; font-size: 12pt; font-family: 'Times New Roman', serif; text-indent: 16px;"><span style="font-family: 標楷體;">教育部個人資料保護聯絡窗口</span></li>
          </ul>
          <p style="margin: 6pt 0cm 6pt 24pt; font-size: 12pt; font-family: 'Times New Roman', serif;"><span style="font-family: 標楷體;">連絡電話：</span>(02)7712-9091</p>
          <p style="text-align: center;"><br /><br /></p>`,
      }
    }
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.ft
  position: absolute
  bottom: 0
  width: 100%
  height: 22vw
  // +bb
  background: url('../assets/footer.png')
  +bgcon
  background-position: 0 100%
  background-size: 100% auto
  box-sizing: border-box
  z-index: 10
  +flexrow
  +pad
    background: url('../assets/footerpad.png')
    +bgcon
    background-position: 0 0
    background-size: 100% auto
    height: 25vw
    // margin-top: 1vw
  +phone
    background: url('../assets/footerphone.png')
    +bgcon
    background-position: 0 0
    background-size: 100% auto
    height: 96vw
    +flexcolumn
    min-height: 360px
  &.home
    position: relative
    bottom: initial

  .ftLeft
    width: 65%
    height: 100%
    position: relative
    // +bb
    +phone
      width: 97%
      height: 70%
      min-height: 252px
      // +bb

    .text
      position: absolute
      line-height: 1.5vw
      letter-spacing: 0.1vw
      text-align: right
      // +bb
      font-size: 0.9vw
      width: 30%
      margin-top: 23%
      margin-left: 25%
      color: #878787
      +smallcom
        width: 40%
        margin-left: 20%
        line-height: 2vw
        +ie
          font-size: 1vw
      +pad
        width: 52%
        // +bb
        // font-size: 0.7vw
        line-height: 2.8vw
        margin-left: 23%
        margin-top: 20%
        +ie
          font-size: 1.5vw
      +phone
        width: 70%
        line-height: 7vw
        font-size: 4vw
        margin-top: 30%
        margin-left: 32%
        text-align: left
        box-sizing: border-box
        padding: 0 50px 0 0
    .edulogo
      position: absolute
      width: 8%
      height: 30%
      margin-left: 58%
      margin-top: 23%
      // +bb
      background: url('../assets/edulogo.png')
      +bgcon
      background-position: 0 0
      +smallcom
        margin-left: 63%
        margin-top: 24%
      +pad
        margin-left: 78%
        margin-top: 21%
        width: 10%
      +phone
        width: 13%
        margin-left: 32%
        margin-top: 11%

  .ftRight
    position: relative
    width: 35%
    // +bb
    +phone
      width: 97%
      height: 30%
      min-height: 108px
    .right_block
      position: absolute
      bottom: 1.5vw
      +smallcom
        bottom: 1vw
      +pad
        bottom: 5vw
      +phone
        right: 10vw
      +phone5
        right: 20vw
      .privacy
        position: relative
        top: 50%
        text-decoration: underline
        cursor: pointer
        &:hover
          color: brown

      .text
        position: relative
        color: #878787
        font-size: 0.9vw
        line-height: 30px
        letter-spacing: 1.5px
        +smallcom
          line-height: 20px
        +pad
          line-height: 30px
        +phone
          font-size: 4vw
.privacy_block
  padding: 0 20px 20px 20px

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue